export default __webpack_public_path__ + "static/media/jogurt_2.8cfeb3c8.jpg";